import { useState, useRef, useEffect } from "react";
import { PREVIEW_VIDEO_SUBMIT } from "../../Utils/apis";

const useConsent = (elementRef, candidate_id, job_id) => {
    const StatesOfVideo = {
        ready: 'All Set, Ready to start recording',
        recording: 'Started storing video chunks',
        recorded: 'Video Recorded Successfully',
        error: 'camera and audio permission is required',
    };
    const [videoStatus, setVideoStatus] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const streamData = useRef({ mixed: '' });
    const videoChunks = useRef({ chunks: [], clear: function () { this.chunks = [] }, });
    const recorder = useRef();

    const startRecordingPreview = () => {
        // it will clear all previous video chunks after that start storing chunks.
        if (recorder?.current?.state === "inactive") {
            videoChunks.current.clear();
            recorder.current.start();
            setVideoStatus(StatesOfVideo.recording);
        }
    }

    const stopRecordingPreview = () => {
        // console.log(streamData.current.mixed.getTracks());

        // it will check if we are storing video chunks then it is assinig a event function to it. we are taking video chunks and creating a new video blob. after that it will create a url and will change status of video recording.
        if (recorder?.current?.state === "recording") {
            recorder.current.onstop = () => {
                videoChunks.current.blob = new Blob(videoChunks.current.chunks, { type: 'video/webm' });
                // videoChunks.current.preivewUrl = URL.createObjectURL(blob);
                setVideoStatus(StatesOfVideo.recorded);
            }
            // we are stoping recorder.
            recorder.current.stop()
        }
    }

    const startInterview = async () => {
        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("applicantId", candidate_id);
            formData.append("jobId", job_id);
            formData.append("video", videoChunks.current.blob);

            const res = await fetch(PREVIEW_VIDEO_SUBMIT, {
                method: "POST",
                body: formData,
                credentials: "include",
            });

            if (!res.ok) {
                throw new Error("Something went wrong while saving video");
            }

            return "success";

        } catch (err) {
            console.error("Error while saving video:", err);
            
            setErrorMessage("Something went wrong while saving your video.");

            throw err;

        } finally {
            setLoading(false);
        }
    };

    const getCameraAndStartPreview = async () => {
        // this will start taking stream and showing that in to preview video element.
        // setLoading(true);
        try {
            // requesting for video and audio permission if granted so strem data will be available other wise will give permission rejection error;
            streamData.current.mixed = await navigator.mediaDevices.getUserMedia(
                {
                    video: {
                        width: { ideal: 360 },
                        height: { ideal: 180 },
                    },
                    audio: {
                        echoCancellation: true,
                        noiseSuppression: true,
                        sampleRate: 44100,
                    },
                }
            );

            // checking for if elemnt if existes then start streaming the perview
            if (elementRef) {
                elementRef.current.srcObject = streamData.current.mixed;
            }

            // creating a MediaRecorder to capture video chunks
            recorder.current = new MediaRecorder(streamData.current.mixed);
            //storing data to a ref state;
            recorder.current.ondataavailable = (e) => videoChunks.current.chunks.push(e.data);

            setVideoStatus(StatesOfVideo.ready);
        } catch {
            setVideoStatus(StatesOfVideo.error);

            setErrorMessage("Camera and microphone is required to continue");
        } finally {
            // setLoading(false);
        }
    }

    useEffect(() => () => {

        // checking for active tracks which we are acessing from this componet if accessing so it will be truned of, to save memory leaking;
        if (recorder?.current?.state !== "inactive") {
            recorder?.current?.stop();
        }

        if (streamData?.current?.mixed) {
            streamData?.current?.mixed?.getTracks()?.forEach(track => track?.stop());
        }
    }, []);


    return {
        StatesOfVideo,
        videoStatus,
        loading,
        startRecordingPreview,
        stopRecordingPreview,
        startInterview,
        videoChunks,
        getCameraAndStartPreview,
        errorMessage,
        setErrorMessage
    }
}

export default useConsent;



// "loadingState" will change twice, one for while checking camera accessing or checking second time when we are uploading interview video;

